import React from 'react';
import { trustBadges } from '../data/content';
export function TrustBadges() {
  return <section aria-label="Purchase details" className="bg-cream py-6 md:py-8" data-id="element-230" data-mp="2oirkd24jv258">
      <ul className="mx-auto grid max-w-page grid-cols-2 gap-3 px-5 md:grid-cols-4 md:gap-4 md:px-8" data-id="element-231" data-mp="32hzmo3w0eqdn">
        {trustBadges.map(b => <li key={b.bottom} className="flex flex-col items-center rounded-xl border border-cream-line bg-white px-3 py-4 text-center" data-id="element-232" data-mp="2xhv488bjjlks">
            <span className="font-display text-[1.35rem] font-extrabold leading-none text-teal md:text-[1.6rem]" data-id="element-233" data-mp="3ce2o17j1ekzj">{b.top}</span>
            <span className="mt-1.5 text-[11px] font-semibold tracking-[0.1em] text-ink/65" data-id="element-234" data-mp="3l8habu1zivs5">{b.bottom}</span>
          </li>)}
      </ul>
    </section>;
}